import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Hidden, Link } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

// COMPONENTS
import ChannelsCarousel, { ChannelsCarouselSlide } from '@/components/Carousels/ChannelsCarousel';

// STYLES
import { ChannelListContainer, Title, ChannelsContainer, ChannelsWrapper, Channel } from './styles';

const ServiceList = props => {
  const [t] = useTranslation();
  const { type, services, onServiceRemove, onUnselectAll } = props;

  const options = {
    slidesPerView: 'auto',
    watchOverflow: true,
    spaceBetween: 10,
  };

  const handleUnselectClick = event => {
    event.preventDefault();
    onUnselectAll();
  };

  return (
    <ChannelListContainer className="channel-list">
      <Hidden smDown>
        <Title type={type}>{t('channels.selectedChannels')}</Title>
      </Hidden>
      {type === 'services' && services.length > 1 ? (
        <Link
          className="channel-list__link"
          color="error"
          onClick={handleUnselectClick}
          component="button"
        >
          {t('buttons.unselectAll')}
        </Link>
      ) : null}
      <ChannelsContainer type={type}>
        <ChannelsWrapper>
          <ChannelsCarousel options={options}>
            {services.map(app => (
              <ChannelsCarouselSlide key={app.app_id}>
                <Tooltip title={app.name}>
                  <Channel
                    className="channel noselect"
                    onClick={() => {
                      onServiceRemove(app);
                    }}
                  >
                    <img
                      src={app.thumbnail || `https://dummyimage.com/64X64?text=${app.name}`}
                      alt={app.name}
                    />
                  </Channel>
                </Tooltip>
              </ChannelsCarouselSlide>
            ))}
          </ChannelsCarousel>
        </ChannelsWrapper>
      </ChannelsContainer>
    </ChannelListContainer>
  );
};

ServiceList.defaultProps = {
  analyticsLocation: '',
};

ServiceList.propTypes = {
  type: PropTypes.string.isRequired,
  services: PropTypes.array.isRequired,
  onServiceRemove: PropTypes.func.isRequired,
  onUnselectAll: PropTypes.func.isRequired,
  analyticsLocation: PropTypes.string,
};

export default React.memo(ServiceList);
